// Classifies a :date_from/:date_to pair into the preset it represents.
// Mirrors the option list in report_builder/builder/_dateRange.vue and
// views/components/graspil/PeriodGranularitySelector.vue: relative tokens
// (today/yesterday/-Nd/now) map to a named preset, anything else is a
// literal datetime string, i.e. a hardcoded/fixed range ('explicit').
export function classifyDateRangeType(dateFrom, dateTo) {
  const df = dateFrom;
  const dt = dateTo;

  if (df === 'today' || df === 'now') {
    return 'today';
  } else if (df === '-2d') {
    return '-2d';
  } else if (df === '-7d') {
    return '-7d';
  } else if (df === '-30d') {
    return '-30d';
  } else if (df === '-90d') {
    return '-90d';
  } else if (df && String(df).startsWith('-') && String(df).endsWith('d')) {
    return 'custom';
  } else {
    if (typeof df === 'string' && typeof dt === 'string' && df.includes(' 00:00:00') && dt.includes(' 23:59:59')) {
      const yd = new Date();
      yd.setDate(yd.getDate() - 1);
      const yStr = yd.getFullYear() + '-' + String(yd.getMonth() + 1).padStart(2, '0') + '-' + String(yd.getDate()).padStart(2, '0');
      if (df.startsWith(yStr) && dt.startsWith(yStr)) return 'yesterday';
    }
    return 'explicit';
  }
}

export function isHardcodedDateRange(dateFrom, dateTo) {
  return classifyDateRangeType(dateFrom, dateTo) === 'explicit';
}
